
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { MailboxModel } from 'models/generated/Distribution.Api.Models.Csp.Mailbox';


const _distribution_MailboxControllerHelper = new Map<string, Object>();
_distribution_MailboxControllerHelper.set('GetMailboxes', MailboxModel);
_distribution_MailboxControllerHelper.set('GetMailboxDetails', MailboxModel);


export const distribution_MailboxControllerHelper = _distribution_MailboxControllerHelper;

